import React, { useState } from 'react';
import { PhoneCall, ShieldAlert, HeartPulse, Flame, Siren, Phone, CheckCircle2 } from 'lucide-react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import styles from './EmergencyContacts.module.css';
import api from '../../api/axios';
import { toast } from 'react-hot-toast';
import { startSiren, stopSiren } from '../../utils/siren';

const EmergencyContacts = () => {
  const [sosTriggered, setSosTriggered] = useState(false);
  const [triggering, setTriggering] = useState(false);
  const [reason, setReason] = useState('');

  const handleTriggerSOS = async () => {
    if (triggering || sosTriggered) return;
    
    try {
      setTriggering(true);
      // Play local sound for 3 seconds
      startSiren();
      setTimeout(() => stopSiren(), 3000);

      // Call API
      await api.post('/security/sos', { reason });
      
      toast.success("SOS Alert sent successfully!");
      setSosTriggered(true);
      
      // Reset button after 10 seconds
      setTimeout(() => setSosTriggered(false), 10000);
      
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to trigger SOS');
      stopSiren();
    } finally {
      setTriggering(false);
      setReason('');
    }
  };
  const contacts = [
    { id: 1, type: 'Security Gate', number: '+91 00000 00000', icon: ShieldAlert, color: 'blue' },
    { id: 2, type: 'Ambulance', number: '108', icon: HeartPulse, color: 'red' },
    { id: 3, type: 'Fire Brigade', number: '101', icon: Flame, color: 'orange' },
    { id: 4, type: 'Police', number: '100', icon: Siren, color: 'blue' },
    { id: 5, type: 'Estate Manager', number: '+91 00000 00000', icon: Phone, color: 'green' },
    { id: 6, type: 'Electrician (On-Call)', number: '+91 00000 00000', icon: Phone, color: 'purple' },
  ];

  return (
    <div className={styles.container}>
      <PageHeader 
        title="Emergency Contacts" 
        breadcrumb={['Resources', 'Emergency Contacts']} 
      />

      <div className={styles.grid}>
        {contacts.map(contact => {
          const Icon = contact.icon;
          return (
            <div key={contact.id} className={`${styles.card} ${styles[contact.color]}`}>
              <div className={styles.iconWrapper}>
                <Icon size={28} />
              </div>
              <div className={styles.info}>
                <h3>{contact.type}</h3>
                <a href={`tel:${contact.number.replace(/\s+/g, '')}`} className={styles.number}>
                  {contact.number}
                </a>
              </div>
              <a href={`tel:${contact.number.replace(/\s+/g, '')}`} className={styles.callBtn}>
                <PhoneCall size={18} />
                Call
              </a>
            </div>
          );
        })}
      </div>

      <div className={styles.alertBox}>
        <div className={styles.alertIconWrapper}>
          <ShieldAlert size={32} />
        </div>
        <div className={styles.alertInfo}>
          <h3>SOS Alert</h3>
          <p>Press the button below to immediately notify the security gate and estate manager of an emergency at your location.</p>
        </div>
        <div className={styles.alertActions}>
          <button 
            className={styles.sosBtn}
            onClick={handleTriggerSOS}
            disabled={triggering || sosTriggered}
            style={{ 
              opacity: triggering ? 0.7 : 1, 
              cursor: (triggering || sosTriggered) ? 'not-allowed' : 'pointer',
              backgroundColor: sosTriggered ? '#16a34a' : undefined
            }}
          >
            {triggering ? 'SENDING...' : sosTriggered ? 'SOS SENT!' : 'TRIGGER SOS'}
          </button>
          <input 
            type="text" 
            placeholder="Optional reason (e.g., Medical, Intruder)" 
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className={styles.reasonInput}
          />
        </div>
      </div>
    </div>
  );
};

export default EmergencyContacts;
